import { render } from "./SafetySubmissionsView.vue?vue&type=template&id=cca55238&ts=true"
import script from "./SafetySubmissionsView.vue?vue&type=script&lang=ts"
export * from "./SafetySubmissionsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__